import React from 'react';
import { motion } from 'framer-motion';
import HeartLoader from '../HeartLoader';
import styles from './SongPage.module.scss';

/**
 * Generic full-bleed loading state used both for the initial song load
 * and the "next song" transition. `message` overrides the default
 * progress text; `progress` feeds the HeartLoader fill.
 */
const SongPageLoadingShell = ({ progress = 0, message }) => {
  const label =
    message ?? (progress > 0 ? `Loading song... ${progress}%` : 'Loading song...');

  return (
    <motion.div
      className={styles.loadingContainer}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <HeartLoader progress={progress} noRise={true} />
      <div className={styles.loadingText}>{label}</div>
    </motion.div>
  );
};

export default SongPageLoadingShell;
